import { createPortal } from "react-dom";
import CompanyHelper from '@/bussiness/CompanyHelper';
import IC_CLOSE from '@/assets/common/ic_collect_close.svg?react';
import IC_PERSONAL from '@/assets/common/ic_personal.svg?react';
import IC_COMPANY from '@/assets/svg/ic_company_default.svg?react';
import CommonLoading from "@/component/CommonLoading";
import IC_CHOSE from '@/assets/common/ic_chose.svg?react';
import { useEffect, useState } from "react";
import { CompanyInfo } from "@/types/company";
import "./index.less";
import { maxMobileWidth } from "@/constants/share";

interface IProp {
  onClose?: () => void;
}

export default function SwitchCompany(prop: IProp) {

  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState<CompanyInfo[]>([]);
  const [currentCompanyId, setCurrentCompanyId] = useState("");
  const [hoverIndex, setHoverIndex] = useState<number>(-1);

  const isMobile = document.documentElement.clientWidth <= maxMobileWidth;

  useEffect(() => {
    CompanyHelper.getCompanyInfo().then((res) => {
      if (res.list) {
        setList(res.list);
        setCurrentCompanyId(res.currId);
      }
      setIsLoading(false);
    }).catch(e => {
      console.log(e);
      setIsLoading(false);
    });
  }, []);

  const closeHandle = () => {
    prop.onClose && prop.onClose();
  }

  const switchHandler = (id: string) => {
    CompanyHelper.switchCompany(id);
  }

  const buildCompany = (model: CompanyInfo, isChose: boolean, index: number) => {
    const isPersonal = model.identityType == 0;
    return (
      <div key={model.identityId} className={`flex p-2.5 items-center ${hoverIndex == index ? "bg-#F4F6F9" : ""} h-14 rd-1 cursor-pointer`}
        onMouseEnter={() => {
          setHoverIndex(index);
        }}
        onMouseLeave={() => {
          setHoverIndex(-1);
        }}
        onClick={() => {
          if (isChose) return;
          switchHandler(model.identityId)
        }}
      >
        {
          model.logo ?
            <img src={model.logo} className="size-10 rd-2" /> :
            <div className="w-10 h-10 rd-2 bg-img flex justify-center items-center">
              {isPersonal ? <IC_PERSONAL className="w-6 h-6" /> : <IC_COMPANY className="w-6 h-6" />}
            </div>
        }
        <span className="ml-4 text-size-4 flex-1 text-#30343C">{isPersonal ? '个人账户' : model.companyName}</span>
        {isChose && <IC_CHOSE className="size-4"></IC_CHOSE>}
        {(hoverIndex == index && !isChose) && <div className="text-size-3 text-#4981F2" >切换</div>}
      </div>
    );
  }

  const buildMobileCompany = (model: CompanyInfo, isChose: boolean) => {
    const isPersonal = model.identityType == 0;
    return (
      <div key={model.identityId} className={`w-20 h-20 flex flex-col justify-center items-center border-0 ${isChose ? "border-l-#4981F2 border-l-3 border-solid bg-#ECEEF3" : ""} mt-10`}
        onClick={() => { switchHandler(model.identityId) }}>
        {
          model.logo ?
            <img src={model.logo} className="size-10 rd-2" /> :
            <div className="w-10 h-10 rd-2 bg-img flex justify-center items-center">
              {isPersonal ? <IC_PERSONAL className="w-4.5 h-4.5" /> : <IC_COMPANY className="w-4.5 h-4.5" />}
            </div>
        }
        <span className="w-14 text-size-2.5 text-#626773 mt-2 whitespace-nowrap overflow-hidden text-ellipsis">{isPersonal ? '个人账户' : model.companyName}</span>
      </div>
    );
  };

  return (
    isMobile ?
      (
        isLoading ?
          <div className="flex justify-center">
            <CommonLoading className="size-6 mt-30" />
          </div> :
          <div className="overflow-scroll h-100%">
            {list.map((item) => buildMobileCompany(item, item.companyId === currentCompanyId))}
          </div>
      )
      :
      createPortal(
        <div className="fixed top-0 flex justify-center items-center w-full h-full bg-black bg-opacity-50">
          <div className="flex flex-col w-100 h-87 rd-2.5 bg-white select-none">
            <div className="flex h-12 w-full border-0 border-b-#ECEEF3 border-b-1 border-solid p-3 justify-between">
              <span className="text-#191D26 text-size-4 font-bold">我所在的企业/组织</span>
              <IC_CLOSE className='w-6 h-6 cursor-pointer' onClick={closeHandle} />
            </div>
            <div className={`flex-1 flex flex-col p-4 overflow-hidden overflow-y-scroll ${isLoading ? "justify-center" : "justify-start"}`}>
              {isLoading ?
                <CommonLoading className="size-6 self-center" />
                :
                <div>
                  {list.map((item, idx) => buildCompany(item, item.companyId === currentCompanyId, idx))}
                </div>}
            </div>
          </div>
        </div>,
        document.body)
  );
}